export default {
    SUPPORT_BUTTON_DISABLED: 'support_button_disabled',
    PRIVACY_POLICY: 'privacy_policy',
    TERMS: 'terms',
    HAS_WHITE_LABEL_ACCESS: 'has_white_label_access',
    HAS_DASHBOARD_WHITE_LABEL_ACCESS: 'has_dashboard_white_label_access',
};
